import index from './interfaces/index'

export default {
    index
}


// WEBPACK FOOTER //
// ./src/api/index.js